import React, {useEffect, useState} from 'react'
import {getSingleQuote, searchQuotes, searchQuotesWithSearchCriteria} from "../common/services/quote-data-service";
import {TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import ShowEmptyListMessage from "../design/components/common/show-empty-list-message";

const QuoteList = ({selectedQuote, setSelectedQuote, allThemes}) => {
    const [initialStep, setInitialStep] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [quotesList, setQuotesList] = useState([]);
    const [filterCriteria, setFilterCriteria] = useState({searchText: '', themeId: ''});
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    useEffect(() => {
        getQuoteList({searchText: '', themeId: ''});
    }, [initialStep]);

    const handleClearSearch = () => {
        const newFilter = {searchText: '', themeId: ''};
        setFilterCriteria(newFilter);
        getQuoteList(newFilter);
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const handleSelectQuote = async (quote) => {
        const existingQuote = await getSingleQuote(quote.id);
        const quoteData = existingQuote.data();
        quoteData.id = existingQuote.id;

        setSelectedQuote(quoteData);
    }

    const handleDetailChanges = (event) => {
        const existingFilter = {...filterCriteria};

        const {name, value} = event.target;
        existingFilter[name] = value;
        setFilterCriteria(existingFilter);

        getQuoteList(existingFilter);
    }

    const getQuoteList = async (existingFilter) => {
        setDataFetchInProgress(true);

        const quotesListResult = await searchQuotesWithSearchCriteria(prepareSearchCriteria(existingFilter));
        setQuotesList(quotesListResult);
        setSelectedQuote(quotesListResult[0]);

        setDataFetchInProgress(false);
    }

    const prepareSearchCriteria = (existingFilter) => {
        const searchCriteriaList = [];

        if (!_.isEmpty(existingFilter?.themeId)) {
            searchCriteriaList.push({field: 'themes.' + existingFilter?.themeId, condition: '==', value: true});
        }

        if (!_.isEmpty(existingFilter?.searchText)) {
            searchCriteriaList.push({
                field: 'textList',
                condition: 'array-contains',
                value: _.toLower(existingFilter?.searchText)
            });
        }

        return searchCriteriaList;
    }

    /* useEffect(() => {
         const timeoutId =
             setTimeout(async () => {
                 getQuoteList();
             }, 300);

         return () => clearTimeout(timeoutId);
     }, [searchText]);*/

    return (
        <>

            <div className="mb-2 flex justify-between">
                <div className="field-container">
                    {/*<div className="field-label">
                        Theme
                    </div>*/}
                    <select
                        className="input-field h-12 -mt-2 -ml-2"
                        id="themeId"
                        name="themeId"
                        value={filterCriteria?.themeId}
                        onChange={handleDetailChanges}>
                        <option value="">Choose Theme</option>
                        {allThemes?.map((theme, index) => (
                            <option key={index}
                                    value={theme?.id}>{theme?.startText}</option>
                        ))}
                    </select>
                </div>

                <input type="text" placeholder="Search"
                       id="searchText"
                       name="searchText"
                       value={filterCriteria?.searchText}
                       onChange={handleDetailChanges}
                       className="h-12 w-full border border-gray-500 p-4 rounded mr-2"/>

                <button
                    onClick={() => handleClearSearch()}
                    className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-12 hover:bg-gray-500 hover:text-white">
                    <div className="p-4">
                        <TrashIcon className="h-6 w-6"/>
                    </div>
                </button>
            </div>

            <div
                className="overflow-y-scroll h-full border border-gray-400 bg-white px-4">
                <div className="py-4">

                    <ShowEmptyListMessage
                        dataList={quotesList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Quotes'}/>

                    {quotesList?.map((quote, index) => (
                        <div key={index} onClick={() => {
                            handleSelectQuote(quote)
                        }}>
                            <div
                                className={`quote-item ${selectedQuote?.id === quote?.id ? 'quote-item-selected' : ''}`}>
                                <span className="px-4">{index + 1}</span>{quote.startText}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </>
    )
}

export default QuoteList
